import React from 'react'
import Image from '../../Components/Image'
import Text from '../../Components/Text'
import { guidancePageContant } from '../../config/pageContent'
import { medias } from '../../config/Resources'

const Face1 = React.lazy(()=> import('../../Components/Faces/Face1')) 
const Face2 = React.lazy(()=> import('../../Components/Faces/Face2')) 
const Face3 = React.lazy(()=> import('../../Components/Faces/Face3')) 
const Face4 = React.lazy(()=> import('../../Components/Faces/Face4')) 
const Face5 = React.lazy(()=> import('../../Components/Faces/Face5')) 
const Face6 = React.lazy(()=> import('../../Components/Faces/Face6')) 
const Face7 = React.lazy(()=> import('../../Components/Faces/Face7')) 
const Face8 = React.lazy(()=> import('../../Components/Faces/Face8')) 
const Face9 = React.lazy(()=> import('../../Components/Faces/Face9')) 
const Face10 = React.lazy(()=> import('../../Components/Faces/Face10')) 
const Face11 = React.lazy(()=> import('../../Components/Faces/Face11')) 
const Face12 = React.lazy(()=> import('../../Components/Faces/Face12')) 
const Face13 = React.lazy(()=> import('../../Components/Faces/Face13')) 

type Props = {}

const Guidance = (props: Props) => {
  return (
    <div>
      <Face1

        Title={<>
        <div className='relative'>
        <Image className='absolute -top-7 -left-11' src={medias.images.guidance.Face1TitleTopIcon}></Image>
        <Text className='text-[80px] font-extrabold'>
          {guidancePageContant.Face1.confusedAboutYourCareer}
        </Text>
      </div>
        </>}
        mainImage={medias.images.guidance.Face1Icon}
        description={guidancePageContant.Face1.indianInstituteOfTechnology}
      />
      <Face2 />
      <Face3 />
      <Face4 />
      <Face5 />
      <Face6 />
      <Face7 />
      <Face8 />
      <Face9 />
      <Face10 />
      <Face11 />
      <Face12 />
      <Face13 />
    </div>
  )
}

export default Guidance